interface Props {
  className?: string;
  color?: string;
}

export default function TimerIcon({className, color}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 18 21"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 2V0H12V2H6ZM8 13H10V7H8V13ZM9 21C7.76667 21 6.604 20.7627 5.512 20.288C4.42 19.8133 3.466 19.1673 2.65 18.35C1.83333 17.5333 1.18767 16.579 0.713 15.487C0.238333 14.395 0.000666667 13.2327 0 12C0 10.7667 0.237667 9.604 0.713 8.512C1.18833 7.42 1.834 6.466 2.65 5.65C3.46667 4.83333 4.421 4.18767 5.513 3.713C6.605 3.23833 7.76733 3.00067 9 3C10.0333 3 11.025 3.16667 11.975 3.5C12.925 3.83333 13.8167 4.31667 14.65 4.95L16.05 3.55L17.45 4.95L16.05 6.35C16.6833 7.18333 17.1667 8.075 17.5 9.025C17.8333 9.975 18 10.9667 18 12C18 13.2333 17.7623 14.396 17.287 15.488C16.8117 16.58 16.166 17.534 15.35 18.35C14.5333 19.1667 13.579 19.8127 12.487 20.288C11.395 20.7633 10.2327 21.0007 9 21ZM9 19C10.9333 19 12.5833 18.3167 13.95 16.95C15.3167 15.5833 16 13.9333 16 12C16 10.0667 15.3167 8.41667 13.95 7.05C12.5833 5.68333 10.9333 5 9 5C7.06667 5 5.41667 5.68333 4.05 7.05C2.68333 8.41667 2 10.0667 2 12C2 13.9333 2.68333 15.5833 4.05 16.95C5.41667 18.3167 7.06667 19 9 19Z"
        fill={color}
      />
    </svg>
  );
}
